export const ADD_ITEM = 'candidateExperience/entities/jobPreferences/ADD_ITEM'
export const UPDATE_ITEM = 'candidateExperience/entities/jobPreferences/UPDATE_ITEM'

export const addItem = (id, item) => ({
  type: ADD_ITEM,
  meta: { id },
  payload: item,
})

export const updateItem = (id, item) => ({
  type: UPDATE_ITEM,
  meta: { id },
  payload: item,
})

const defaultEntity = {}
const entity = (state = defaultEntity, { type, payload }) => {
  switch (type) {
    case ADD_ITEM:
    case UPDATE_ITEM:
      return { ...state, ...payload }

    default:
      return state
  }
}

const defaultMap = {}
const map = (state = defaultMap, { type, meta, payload }) => {
  switch (type) {
    case ADD_ITEM:
    case UPDATE_ITEM:
      return {
        ...state,
        [meta.id]: entity(state[meta.id], { type, payload }),
      }

    default:
      return state
  }
}

export default map

export const getJobPreferencesMap = state => state.entities.jobPreferences || defaultMap
export const getJobPreferencesEntity = (state, id) => state.entities.jobPreferences[id] || defaultEntity
